// バックエンドの SchoolOrderChangeRequest::MAX_CHANGE_NUM と対で管理する
export const MAX_CHANGE_NUM = 10;

// バックエンドの SchoolOrderChangeRequest::ACTIVE_LEARNING_MATERIAL_NAMES と対で管理する
export const ACTIVE_LEARNING_MATERIAL_NAMES = ["実践編1", "実践編2"];
